import { getVueI18n } from '../i18n'
import type { ProjectManifest } from '../types/ProjectManifest'
import { merge } from 'lodash-es'
import { I18N_URL } from '../constants'

const isLocaleFetched = new Map<string, boolean>()

export async function loadLocale(
  manifest: ProjectManifest,
  locale: string
): Promise<boolean> {
  const i18n = getVueI18n()

  if (isLocaleFetched.has(locale)) return true
  isLocaleFetched.set(locale, true)

  const fileName = manifest.locales[locale]?.fileName
  if (fileName === undefined) {
    return false
  }

  const messages = await fetchLocale(fileName)
  const existingMessages = (i18n.messages as any)[locale] ?? {}
  const mergedMessages = merge({}, existingMessages, messages)

  i18n.setLocaleMessage(locale, mergedMessages)
  return messages !== undefined
}

function fetchLocale(fileName: string) {
  const url = `${I18N_URL}/${fileName}`

  return fetch(url)
    .then((res) => {
      if (!res.ok) return undefined
      return res.json()
    })
    .catch(() => undefined)
}
